import { Observable, tap } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CACHE_TIMEOUT } from '@shared/constants';
import { withAPICache } from '@shared/interceptors';
import { EmployeesRepository } from '@shared/state/employees/employees.repository';

import { ConfigService } from '../core/config.service';

@Injectable({ providedIn: 'root' })
export class EmployeeService {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(
		private readonly http: HttpClient,
		private readonly repo: EmployeesRepository,
		private readonly env: ConfigService
	) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - get
	 **-------------------------------------------------------------------------------------
	 */
	public getList(companyId): Observable<any> {
		const url = `${this.env.get<string>(
			'employeesEndPoint'
		)}/company-employees?companyId=${companyId}`;
		return this.http
			.get(url, {
				context: withAPICache({
					ttl: CACHE_TIMEOUT,
				}),
			})
			.pipe(tap(resp => this.repo.add(resp)));
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - saveEmployeeTip
	 **-------------------------------------------------------------------------------------
	 */
	public saveEmployeeTip({
		reservation_id,
		employee_id,
		gratuity_amount,
	}: {
		reservation_id: number;
		employee_id: number;
		gratuity_amount: number;
	}): Observable<boolean> {
		const url = `${this.env.get<string>('employeesEndPoint')}/gratuity`;
		return this.http.post<boolean>(url, {
			reservation_id,
			employee_id,
			gratuity_amount,
		});
	}
}
